// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__5l5At {
  width: 48px;
  height: 48px;
  margin: 20px 40px;
  margin-top: 40px;
}

.styles_loader__fLif3 {
  transform: rotateZ(45deg);
  perspective: 1000px;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  color: #000;
}

.styles_loader__fLif3:before,
.styles_loader__fLif3:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
  border-radius: 50%;
  transform: rotateX(70deg);
  animation: 1s styles_spin__edZyY linear infinite;
}

.styles_loader__fLif3:after {
  color: #FF3D00;
  transform: rotateY(70deg);
  animation-delay: 0.4s;
}

@keyframes styles_rotate__ukSKB {
  0% {
    transform: translate(-50%, -50%) rotateZ(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotateZ(360deg);
  }
}
@keyframes styles_rotateccw__cPUrI {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(-360deg);
  }
}
@keyframes styles_spin__edZyY {
  0%, 100% {
    box-shadow: 0.2em 0px 0 0px currentcolor;
  }
  12% {
    box-shadow: 0.2em 0.2em 0 0 currentcolor;
  }
  25% {
    box-shadow: 0 0.2em 0 0px currentcolor;
  }
  37% {
    box-shadow: -0.2em 0.2em 0 0 currentcolor;
  }
  50% {
    box-shadow: -0.2em 0 0 0 currentcolor;
  }
  62% {
    box-shadow: -0.2em -0.2em 0 0 currentcolor;
  }
  75% {
    box-shadow: 0px -0.2em 0 0 currentcolor;
  }
  87% {
    box-shadow: 0.2em -0.2em 0 0 currentcolor;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SplashLoader/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AACA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAEJ;;AACI;;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gDAAA;AAEN;;AAAI;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAGN;;AAAE;EACE;IACE,8CAAA;EAGJ;EADE;IACE,gDAAA;EAGJ;AACF;AAAE;EACE;IACE,6CAAA;EAEJ;EAAE;IACE,gDAAA;EAEJ;AACF;AACE;EACE;IAEE,wCAAA;EAAJ;EAEE;IACE,wCAAA;EAAJ;EAEE;IACE,sCAAA;EAAJ;EAEE;IACE,yCAAA;EAAJ;EAEE;IACE,qCAAA;EAAJ;EAEE;IACE,0CAAA;EAAJ;EAEE;IACE,uCAAA;EAAJ;EAEE;IACE,yCAAA;EAAJ;AACF","sourcesContent":[".container{\n    width: 48px;\n    height: 48px;\n    margin: 20px 40px;\n    margin-top:40px;\n}\n.loader {\n    transform: rotateZ(45deg);\n    perspective: 1000px;\n    border-radius: 50%;\n    width: 48px;\n    height: 48px;\n    color: #000;\n\n  }\n    .loader:before,\n    .loader:after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: inherit;\n      height: inherit;\n      border-radius: 50%;\n      transform: rotateX(70deg);\n      animation: 1s spin linear infinite;\n    }\n    .loader:after {\n      color: #FF3D00;\n      transform: rotateY(70deg);\n      animation-delay: .4s;\n    }\n\n  @keyframes rotate {\n    0% {\n      transform: translate(-50%, -50%) rotateZ(0deg);\n    }\n    100% {\n      transform: translate(-50%, -50%) rotateZ(360deg);\n    }\n  }\n\n  @keyframes rotateccw {\n    0% {\n      transform: translate(-50%, -50%) rotate(0deg);\n    }\n    100% {\n      transform: translate(-50%, -50%) rotate(-360deg);\n    }\n  }\n\n  @keyframes spin {\n    0%,\n    100% {\n      box-shadow: .2em 0px 0 0px currentcolor;\n    }\n    12% {\n      box-shadow: .2em .2em 0 0 currentcolor;\n    }\n    25% {\n      box-shadow: 0 .2em 0 0px currentcolor;\n    }\n    37% {\n      box-shadow: -.2em .2em 0 0 currentcolor;\n    }\n    50% {\n      box-shadow: -.2em 0 0 0 currentcolor;\n    }\n    62% {\n      box-shadow: -.2em -.2em 0 0 currentcolor;\n    }\n    75% {\n      box-shadow: 0px -.2em 0 0 currentcolor;\n    }\n    87% {\n      box-shadow: .2em -.2em 0 0 currentcolor;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__5l5At`,
	"loader": `styles_loader__fLif3`,
	"spin": `styles_spin__edZyY`,
	"rotate": `styles_rotate__ukSKB`,
	"rotateccw": `styles_rotateccw__cPUrI`
};
export default ___CSS_LOADER_EXPORT___;
